export default "__VITE_ASSET__DtU1YI0T__"